import { InternalContactDetail } from '../../../../components/Contact/InternalContact';

export function TBMContactInternalContactDetail() {
  return <InternalContactDetail />;
}
